import { render, staticRenderFns } from "./CarouselPosts.vue?vue&type=template&id=cdae7ae2&scoped=true"
import script from "./CarouselPosts.vue?vue&type=script&lang=js"
export * from "./CarouselPosts.vue?vue&type=script&lang=js"
import style0 from "./CarouselPosts.vue?vue&type=style&index=0&id=cdae7ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdae7ae2",
  null
  
)

export default component.exports